import { render, staticRenderFns } from "./AxFilesystemNodeDelete.vue?vue&type=template&id=dee1435c&scoped=true&"
import script from "./AxFilesystemNodeDelete.vue?vue&type=script&lang=ts&"
export * from "./AxFilesystemNodeDelete.vue?vue&type=script&lang=ts&"
import style0 from "./AxFilesystemNodeDelete.vue?vue&type=style&index=0&id=dee1435c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dee1435c",
  null
  
)

export default component.exports